import React from 'react'

const ExpanderBrandInvert = () => (
  <svg className="icon">
    <use
      xlinkHref={`/Static/Images/icons.svg?=${process.env.BUILD_VERSION_ID}#icon--expander-brand-invert`}
    />
  </svg>
)

export default ExpanderBrandInvert
